import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import config from '../../helpers/config';

const useStyles = makeStyles(theme => ({
    bgClass: props => ({
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: props.boxShadow || 'inset 0px 0px 100px #dadada',
        backgroundImage: `url(${config.S3Endpoint}${props.imgUrl || ''})`,
        height: props.height || '100%'
    })
}));

const BackgroundImage = (props) => {
    const classes = useStyles(props);
    return (<div className={classes.bgClass} />)
}

export default BackgroundImage;


// WEBPACK FOOTER //
// ./src/client/components/BackgroundImage.js